export default __webpack_public_path__ + "static/media/File_No_5.85973e22.mp3";